<template>
  <div class="author" itemprop="author" itemtype="http://schema.org/Person">
    <Avatar size="60">
      <a v-if="author.url" :href="author.url">
        <img :src="author.image" :alt="`${author.name} portrait`" />
      </a>
      <img v-else :src="author.image" :alt="`${author.name} portrait`" />
    </Avatar>
    <div class="author__content">
      <VText itemprop="name">
        <strong>
          <a v-if="author.url" :href="author.url">
            {{ author.name }}
          </a>
          <template v-else>{{ author.name }}</template>
        </strong>
      </VText>
      <VText>{{ author.bio }}</VText>
    </div>
  </div>
</template>

<script>
import { Avatar, VText } from '@campsite-bio/component-lib';

export default {
  components: {
    Avatar,
    VText,
  },

  props: {
    author: {
      type: Object,
      required: true,
    },
  },

  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.author {
  align-items: center;
  display: flex;

  &__content {
    padding-left: 1rem;
  }
}
</style>
